import React from 'react';
import './Prestudent.css'
import {  Layout, Row, Col,Form, Input, Button, Checkbox, message } from 'antd';
import { Route, Link, Switch } from "react-router-dom"
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import axios from 'axios';
import decode from 'jwt-decode';
import {persistor, store} from "./store";
const {Content } = Layout;


export default class Prestudent extends React.Component{
// const Prestudent = () => {
  componentDidMount() {

    persistor.purge() // Clear everything
    window.localStorage.removeItem('session_token')
    store.dispatch({type: 'RESET'})
  }
  
  render() {

  return (
    <Layout style={{ 
      minHeight: '100vh',
      padding: '25px',
      // paddingTop: '30%'
       }}>
      <Content>
        <div className="site-layout-background" >
        <Row >
          <Col span={8} offset={8}>
            <div style={{
              backgroundImage:'url("/eportfolio_logo.png")',
              backgroundRepeat:'no-repeat',
              backgroundPosition:'center',
              marginTop: '50px',
              marginBottom: '100px',
              width: '100%',
              height: '300px'
            }}>
            </div>
            <div>
              <h1>
                <center>가입신청이 완료되었습니다. <br></br>교육실의 가입 승인 이후<br></br>로그인이 가능합니다.</center>
              </h1>
            </div>
              {/* <Form.Item> */}
                {/* <Form.Item name="remember" valuePropName="checked" noStyle>
                  <Checkbox>Remember me</Checkbox>
                </Form.Item> */}

                {/* <a className="login-form-forgot" href="" disabled> */}
                  {/* Forgot password */}
                {/* </a> */}
              {/* </Form.Item> */}

          </Col>
        </Row>
        </div>
      </Content>
    </Layout>
  );

  }
};
